/* eslint-disable no-undef */
const MDMloader = (function () {
	const PARTICLES_WRAPPER_ID = 'particles-js';
	const themeClass = document.querySelector('html').classList.toString();

	const loaderEl = document.querySelector('.initial-loader');
	const projectLabelEl = loaderEl.querySelector(`.label`);
	const statusLabelEl = loaderEl.querySelector(`.status`);
	const progressLabelEl = loaderEl.querySelector(`.progress`);

	particlesJS.load(PARTICLES_WRAPPER_ID, `assets/json/particlesjs-config-${themeClass}.json`, () => {
		loaderEl.classList.remove('hidden');
	});

	return {
		loaderEl,
		projectLabelEl,
		statusLabelEl,
		progressLabelEl,
	};
})();
